<template>
  <el-dialog :visible.sync="visible">
    <div class="app-container">
      <h4 class="form-header h4">基本信息</h4>
      <el-form ref="form" :model="form" label-width="80px">
        <el-row>
          <el-col :span="8" :offset="2">
            <el-form-item label="公司名称" prop="nickName">
              <el-input v-model="form.nickName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="2">
            <el-form-item label="登录账号" prop="userName">
              <el-input  v-model="form.userName" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <h4 class="form-header h4">角色信息</h4>
      <el-table v-loading="loading" :row-key="getRowKey" @row-click="clickRow" ref="table" @selection-change="handleSelectionChange" :data="roles">
        <el-table-column label="序号" type="index" align="center">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column label="角色编号" align="center" prop="roleId" />
        <el-table-column label="角色名称" align="center" prop="roleName" />
        <el-table-column label="权限字符" align="center" prop="roleKey" />
        <el-table-column label="创建时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :page.sync="pageNum" :limit.sync="pageSize" />
      <el-form label-width="100px">
        <el-form-item style="text-align: center;margin-left:-120px;margin-top:30px;">
          <el-button type="primary" @click="submitForm()">提交</el-button>
          <el-button @click="close()">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import {Message} from "element-ui";
import { rolePage, userBindRole } from "@/api/role";
import {parseTime} from "@/util/tool";

export default {
  props: {
    user: {
      type: Object,
      default: ()=> {return null}
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(n) {
      if (n) {
        this.init();
      }
    }
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 分页信息
      total: 0,
      pageNum: 1,
      pageSize: 10,
      // 选中角色编号
      roleIds:[],
      // 角色信息
      roles: [],
      // 用户信息
      form: {}
    };
  },
  created() {

  },
  methods: {
    parseTime,
    init() {
      this.form = this.user;
      this.loading = true;
      let data = {
        pageNo: this.pageNum,
        pageSize: this.pageSize,
        search: {

        }
      }
      rolePage(data).then(res => {
        this.roles = res.data.data;
        this.loading = false;
      });
    },
    /** 单击选中行数据 */
    clickRow(row) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.roleIds = selection.map((item) => item.roleId);
    },
    // 保存选中的数据编号
    getRowKey(row) {
      return row.roleId;
    },
    /** 提交按钮 */
    submitForm() {
      let _this = this;
      const userId = this.form.userId;
      const roleIds = this.roleIds;
      userBindRole({ userId: userId, roleId: roleIds }).then((res) => {
        if (res.ok) {
          Message({type:'success', message: '授权成功'});
          _this.close();
        } else {
          Message({type: 'error', message: res.msg});
        }
      });
    },
    reset() {
      this.total= 0;
      this.pageNum= 1;
      this.pageSize= 10;
      this.roleIds= [];
      this.roles= [];
      this.form={};
    },
    /** 关闭按钮 */
    close() {
      this.reset();
      this.$emit('closeRoles');
    },
  },
};
</script>
